export function randomStringGenerator(n) {
    const letters = "qwertyuiopasdffghjklzxcvbnm";
    let result = "";
    while (result.length <= n) {
        const index = Math.floor(Math.random() * letters.length);
        result += letters[index];
    }
    return result;
}